import { cn } from '@dialogueconsulting/sked-ui/lib/utils'
import startCase from 'lodash.startcase'

import type { PlatformIconProps } from 'Components/Common/PlatformIcon'
import PlatformIcon from 'Components/Common/PlatformIcon'
import {
  handleStatusStateBg,
  handleStatusStateColor,
} from 'Components/UpcomingPostCard'
import getReviewKeyFromURL from 'utils/getReviewKeyFromURL'

import PostTime from './PostTime'

interface StatusLabelProps {
  status: string
  statusLabel?: string
  platform: PlatformIconProps['platform']
  time: string
  isMobile?: boolean
  isReadOnly: boolean
  className?: string

  postId: string
  isExpanded?: boolean
  updatePostState: (
    reviewKey: string,
    postId: string,
    finalState: string
  ) => void
  isDisplayTime: boolean
  children?: unknown
}

export const StatusLabel = (props: StatusLabelProps) => {
  const {
    status,
    statusLabel,
    platform,
    time,
    isMobile,
    isReadOnly,
    className,
    postId,
    isExpanded,
    updatePostState,
    isDisplayTime,
  } = props
  const reviewKey = getReviewKeyFromURL(window.location.href)

  const handleUndo = (event: React.MouseEvent) => {
    updatePostState(reviewKey, postId, 'pending')
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <div
      className={cn(
        'absolute -left-[1.5px] -top-[1.5px] z-[2] flex h-9 items-center justify-between rounded-[5px_0_5px_0] px-[10px] py-[7px] text-xs font-bold [&>div]:flex [&>div]:items-center',
        status === 'pending' ? 'min-w-[180px]' : 'min-w-[220px]',
        isReadOnly && isMobile && '!min-w-[calc(100%-55px)]',
        className
      )}
      style={{
        background: handleStatusStateBg(status, isReadOnly),
        color: handleStatusStateColor(status),
      }}
    >
      <div>
        <div className="mr-2 [&_svg]:w-5">
          <PlatformIcon platform={platform} />
        </div>
        <div>
          <span className={cn(isReadOnly && 'text-white')}>
            {isReadOnly
              ? time
              : status === 'pending'
                ? 'Pending'
                : statusLabel || startCase(status)}
          </span>
        </div>
      </div>
      <div className="absolute right-3 flex h-9 items-center gap-[10px]">
        <div className="m-0 flex h-9 items-center justify-center">
          {isMobile && isDisplayTime && <PostTime time={time} isMobile />}
        </div>
        {status !== 'pending' && isMobile && (
          <div
            onClick={handleUndo}
            className="cursor-pointer text-xs italic text-white"
          >
            Undo
          </div>
        )}
        {isMobile && (
          <i
            aria-hidden="true"
            className={cn(
              'fa-solid text-[20px]',
              isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'
            )}
          />
        )}
      </div>
    </div>
  )
}
